import { render } from "./DonationCategoryManageCreatePage.vue?vue&type=template&id=1130a81e&lang=true"
import script from "./DonationCategoryManageCreatePage.vue?vue&type=script&lang=js"
export * from "./DonationCategoryManageCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__